import type { Theme } from '@mui/material';

export const styles = {
  tableRow: (theme: Theme) => ({
    ':hover': {
      cursor: 'pointer',
      backgroundColor: theme.colors.neutral[100],
    },
  }),
  dueDateWarning: (theme: Theme) => ({
    color: theme.colors.error[500],
    fontWeight: 700,
  }),
};
